export const SET_CHEAT_MODE = 'SET_CHEAT_MODE';
export const SET_FINISH_LEVEL_CHEAT = 'SET_FINISH_LEVEL_CHEAT';
export const CLEAR_FINISH_LEVEL_CHEAT = 'CLEAR_FINISH_LEVEL_CHEAT';
export const SET_PAGE_WITH_LIFES = 'SET_PAGE_WITH_LIFES';
export const SET_PAGE_WITH_GAME = 'SET_PAGE_WITH_GAME';
